import React, { useEffect, useRef, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SECONDS = 23 * 3600 + 58 * 60 + 30;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function UrgencySection() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  const [active, setActive] = useState(false);
  const sectionRef = useRef<HTMLDivElement | null>(null);

  // El contador solo corre cuando la sección está en pantalla (menos trabajo en el hilo principal).
  useEffect(() => {
    const node = sectionRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setActive(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => setActive(entry.isIntersecting), {
      threshold: 0
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!active) return;
    const interval = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, [active]);
  const units = [{
    value: pad(Math.floor(secondsLeft / 3600)),
    label: 'hs'
  }, {
    value: pad(Math.floor(secondsLeft % 3600 / 60)),
    label: 'min'
  }, {
    value: pad(secondsLeft % 60),
    label: 'seg'
  }];
  return <section className="w-full bg-cream px-5 py-14" aria-labelledby="urgency-title" data-id="element-296" data-mp="37jcb8vs5442p">
      <div ref={sectionRef} className="mx-auto max-w-xl rounded-3xl border-2 border-blush-500/40 bg-blush-100 p-7 text-center shadow-card" data-id="element-297" data-mp="3cglyq5vyy5nw">
        <h2 id="urgency-title" className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-blush-600" data-id="element-298" data-mp="3glbt1qazbc6p">
          El precio de lanzamiento termina en
        </h2>

        <div className="mt-5 flex items-end justify-center gap-3" role="timer" data-id="element-299" data-mp="3qgwp77td9i8j">
          {units.map(unit => <div key={unit.label} className="min-w-[78px] rounded-2xl border-2 border-forest-100 bg-white px-3 py-3" data-id="element-300" data-mp="1r5vlgfcpdyix">
              <span className="block font-display text-3xl font-extrabold tabular-nums text-forest-800 sm:text-4xl" data-id="element-301" data-mp="1w5hxwmkpjaqo">
                {unit.value}
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-forest-900/45" data-id="element-302" data-mp="1k25sww24xy73">
                {unit.label}
              </span>
            </div>)}
        </div>

        <p className="mt-4 text-xs font-bold uppercase tracking-wider text-forest-900/60" data-id="element-303" data-mp="1t1j69ztdr6x3">
          Después sube el precio y no vuelve a bajar
        </p>

        <div className="mt-7 border-t-2 border-dashed border-blush-500/30 pt-5" data-id="element-304" data-mp="26z7fubhzyrmu">
          <p className="flex items-center justify-center gap-2 font-display text-sm font-extrabold text-forest-800" data-id="element-305" data-mp="22zq9lfuqxqgm">
            <FlameIcon className="h-4 w-4 text-blush-600" aria-hidden="true" data-id="element-306" data-mp="2gt7tj1rch576" />
            Cupos al precio de lanzamiento · quedan pocos
          </p>
          <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-307" data-mp="2qqm9l09cvryy">
            <div className="h-full w-[65%] rounded-full bg-blush-500" data-id="element-308" data-mp="35dkwchx9py7c" />
          </div>
          <p className="mt-2 text-[11px] font-bold uppercase tracking-wider text-forest-900/55" data-id="element-309" data-mp="39ctq3msb5w2w">
            65% de los cupos tomados
          </p>
        </div>
      </div>
    </section>;
}